export class IETFLanguage {
  constructor(readonly name: 'en' | 'pt-br' | 'es-419' | 'es' | 'pl' | 'it') {}
}
